import actionTypes from '../actionTypes';

export const FETCH_PROFILE = actionTypes('FETCH_PROFILE');
